import _objectSpread from "/home/runner/_work/mono/mono/node_modules/.pnpm/@babel+runtime@7.9.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
/**
 * Get request parameters. Will filter out any unsupported parameters.
 *
 * @param {Object} options Provided input options from calling method.
 * @param {Object} [defaults={}] Default options for the parameters.
 * @returns {Object}
 */
export default function getCursorPaginationParams(options) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var params = _objectSpread(_objectSpread({}, defaults), options);
  if (options.usePagination) {
    params.use_pagination = options.usePagination;
  }
  if (options.next) {
    params.next = options.next;
  }
  if (options.previous) {
    params.previous = options.previous;
  }
  if (options.limit) {
    params.limit = options.limit;
  }
  return params;
}